import styled from 'styled-components';
import { colourPalette, cssScreens } from 'styles/styles';

export const MapStepColumnStyle = {
  Container: styled.div`
    display: flex;
    @media screen and (max-width: ${cssScreens.tablet}) {
      flex-direction: column;
    }
  `,
  Box: styled.div`
    width: 65%;
    background: ${colourPalette.neutral0};
    border: 1px solid ${colourPalette.neutral300};
    border-radius: 8px;
    margin-bottom: 24px;
    @media screen and (max-width: ${cssScreens.tablet}) {
      width: 100%;
    }
  `,
};
